export default import.meta.ROLLDOWN_FILE_URL_QUH8bT7ABDHAMcPvFR9Rmw